import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xE5184D6B16aE42D16fBA7210277Ee6a7a23352Fd', // TODO
  [ChainId.BSCTESTNET]: '0x1852B91c4A2d817e8a479e91c1c2607E46FEE414'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
